import { createReducer, on } from '@ngrx/store';
import { authActions } from '../actions/auth.action';
export interface AuthState {
  loading: boolean;
  loaded: boolean;
  loadedFail: boolean;
  user: any;
}

export const INITIAL_STATE: AuthState = {
  loading: false,
  loaded: false,
  loadedFail: false,
  user: null
};

export const authReducer = createReducer(
  INITIAL_STATE,
  on(authActions.getUserDataFromStorageAction, (state, payload) => ({
    ...state,
    loading: false,
    loaded: false,
    loadedFail: true,
    user: payload
  }))
);
